const checkPersonalizedContentFromSurvey = () => {
    if (window.location.href.includes('fw_survey') && typeof originalUtmContent !== 'undefined') {
        const search = window.location.search;

        //- Split window.location.search on '&' to get array of all params
        const searchSplit = search.split('&');

        //- Filter and storage 'fw_survey' from all indices from array
        const answers = searchSplit.filter((answer) => answer.startsWith("fw_survey"));

        //- Convert answers to string to get only answers and pop from param Name
        const getAnswers = answers.toString().split('=').pop();
        // console.log('getAnswers', getAnswers)

        const splitAnswers = getAnswers.split('_');
        // console.log('splitAnswers', splitAnswers);

        //- Storage node elements
        const personalizedWrapper = $('#personalizedWrapper');
        const personalizedWrapperHighlighted = $('#personalizedWrapperHighlighted');

        let regularContentArray = [],
            regularContentString = '',
            regularClauseValue = '',
            highlightedContentArray = [],
            highlightedContentString = '',
            highlightedClauseValue = '';

        splitAnswers.forEach(function (item) {
            $.each(personalizedContent, function (key, value) {
                if (item == key) {
                    // console.log('conditional#1', item, key);
                    // console.log('conditional#2', value);

                    if (item.match("^" + personalizedWrapperHighlightedString + "")) {
                        highlightedContentArray.push(value);

                    } else {
                        regularContentArray.push(value);
                    }
                }
            })
        });

        //- Handle regularClauseValue for Regular Content 
        // console.log('regularContentArray', regularContentArray);
        // console.log('regularContentArray.length', regularContentArray.length);

        if (regularContentArray.length > 0) {
            if (regularContentArray.length >= 2) {
                for (var i = 0; i < regularContentArray.length; i++) {
                    if (i < regularContentArray.length - 2) {
                        regularClauseValue = ", ";
                    } else if (i == regularContentArray.length - 2) {
                        regularClauseValue = ' and ';
                    } else if (i > regularContentArray.length - 2) {
                        regularClauseValue = '';
                    }

                    regularContentString += regularContentArray[i] + regularClauseValue;
                }
            } else {
                regularContentString = regularContentArray[0]
            }

            // console.log('>', regularContentString);
            personalizedWrapper.html("" + regularContentString + ", ");
        }

        //- Handle highlightedContentArray for Highlighted Content
        // console.log('highlightedContentArray', highlightedContentArray);
        // console.log('highlightedContentArray.length', highlightedContentArray.length);

        if (highlightedContentArray.length > 0) {
            if (highlightedContentArray.length >= 2) {
                for (var i = 0; i < highlightedContentArray.length; i++) {
                    if (i < highlightedContentArray.length - 2 || i > highlightedContentArray.length - 2) {
                        highlightedClauseValue = ", ";
                    } else if (i == highlightedContentArray.length - 2) {
                        highlightedClauseValue = ' and ';
                    }

                    highlightedContentString += highlightedContentArray[i] + highlightedClauseValue;
                }
            } else {
                highlightedContentString = highlightedContentArray[0]
            }

            // console.log('>', highlightedContentString);
            personalizedWrapperHighlighted.html("" + highlightedContentString + "");
        }

        /**
         * Update utm_content if user clicked on any answer
         * _qs-drc-fb-rc_v05_fnSurveyPersonalizedContent-opt_n -> _qs-drc-fb-rc_v05_UI_fnSurveyPersonalizedContent-opt_n
         * _qs-drc-fb-rc_v05_fnSurveyPersonalizedContent-opt_y_XX -> _qs-drc-fb-rc_v05_UI_fnSurveyPersonalizedContent-opt_y_XX
         */
        const utmContentSplit = originalUtmContent.split('_'); //- array can have a length of 5 or 6 indexes, depending on opt_n or opt_y_XX
        // console.log('utmContentSplit', utmContentSplit);

        let newUtmContent = '';

        //- Define new utm_content based on array.length
        if(utmContentSplit.length == 6) {
            newUtmContent = '_' + utmContentSplit[1] + '_'+ utmContentSplit[2] + '_UI_' + utmContentSplit[3] + '_' + utmContentSplit[4] + '_' + utmContentSplit[5];

        } else {
            newUtmContent = '_' + utmContentSplit[1] + '_'+ utmContentSplit[2] + '_UI_' + utmContentSplit[3] + '_' + utmContentSplit[4];
        }

        // console.log('newUtmContent', newUtmContent);

        //- Update data-param and href CTA
        $('[data-param]').each(function(index){
            const paramTargetPrefix = $(this).attr('data-param').split('utm_content=')[0];
            $(this).attr('data-param', `${paramTargetPrefix}utm_content=${newUtmContent}`);

            const hrefTargetPrefix = $(this).attr('href').split('utm_content=')[0];
            $(this).attr('href', `${hrefTargetPrefix}utm_content=${newUtmContent}`);
        });
    }
}

checkPersonalizedContentFromSurvey();